namespace TabAurous {
    export interface POSInvoicePrintRequest extends Serenity.ServiceRequest {
        Invoice?: TabAurous.Retail.POSSalesRow;
    }
}
